import type { MatchSuggestion } from '../../types';

export type GroupShape = 'fan-out' | 'fan-in' | 'complex';

export function groupSuggestions(suggestions: MatchSuggestion[]): MatchSuggestion[][] {
  const n = suggestions.length;
  if (n === 0) return [];

  const parent = Array.from({ length: n }, (_, i) => i);

  function find(x: number): number {
    while (parent[x] !== x) {
      parent[x] = parent[parent[x]];
      x = parent[x];
    }
    return x;
  }

  function union(a: number, b: number) {
    parent[find(a)] = find(b);
  }

  const byFeed = new Map<string, number[]>();
  const byAsset = new Map<string, number[]>();

  suggestions.forEach((s, i) => {
    const feedId = s.unprocessedProduct.id;
    const assetId = s.suggestedAsset.id;

    const feedList = byFeed.get(feedId);
    if (feedList) feedList.push(i);
    else byFeed.set(feedId, [i]);

    const assetList = byAsset.get(assetId);
    if (assetList) assetList.push(i);
    else byAsset.set(assetId, [i]);
  });

  for (const indexes of byFeed.values()) {
    for (let i = 1; i < indexes.length; i++) union(indexes[0], indexes[i]);
  }
  for (const indexes of byAsset.values()) {
    for (let i = 1; i < indexes.length; i++) union(indexes[0], indexes[i]);
  }

  const groups = new Map<number, MatchSuggestion[]>();
  suggestions.forEach((s, i) => {
    const root = find(i);
    const group = groups.get(root);
    if (group) group.push(s);
    else groups.set(root, [s]);
  });

  return [...groups.values()];
}

export function classifyGroup(group: MatchSuggestion[]): GroupShape {
  const uniqueFeeds = new Set(group.map(s => s.unprocessedProduct.id));
  const uniqueAssets = new Set(group.map(s => s.suggestedAsset.id));
  if (uniqueFeeds.size === 1 && uniqueAssets.size > 1) return 'fan-out';
  if (uniqueAssets.size === 1 && uniqueFeeds.size > 1) return 'fan-in';
  return 'complex';
}
